<template>
  <md-tabs class="md-transparent" :md-dynamic-height="false">
    <md-tab id="tab-ems" md-label="EMS">
      <template-cases product-type="EMS" />
    </md-tab>
    <md-tab id="tab-nursing" md-label="Nursing">
      <template-cases product-type="NURSING" />
    </md-tab>
    <md-tab id="tab-military" md-label="Military">
      <template-cases product-type="MILITARY" />
    </md-tab>
  </md-tabs>
</template>

<script>
import TemplateCases from '../TemplateCases';

export default {
  name: 'template-tabs',
  components: {
    TemplateCases
  }
}
</script>

<style scoped>
.md-tabs {
  height: 100%;
}

.md-tabs >>> .md-tabs-navigation .md-button {
  font-size: 16px;
}

.md-tabs >>> .md-tabs-container,
.md-tabs >>> .md-tabs-content,
.md-tabs >>> .md-tab {
  height: 100% !important;
}
</style>